import { Platform } from '../web/react-native';
import { FAB, Button } from './paper';
import styled from './styled';
import * as Colors from '../helpers/Colors';

export const FabButton = styled(FAB).attrs({
  color: '#fff',
  uppercase: false,
})`
  font-size: 16px;
  opacity: ${(props) => (props.disabled ? 0.3 : 1)};
  background-color: #00a3e0;
  position: absolute;
  right: 10px;
  bottom: ${(_props) => ('25px')};
`;

export const ActionButton = styled(Button).attrs({
  mode: 'contained',
  uppercase: false,
  contentStyle: {
    padding: 7,
  },
  labelStyle: { letterSpacing: 0, fontSize: 16, color: '#fff' },
})`
  background-color: ${Colors.secondary};
  opacity: ${(props) => (props.disabled ? 0.3 : 1)};
`;

interface CustomTextButtonProps {
  emphasize: boolean;
}

export const TextButton = styled(Button).attrs((props: CustomTextButtonProps) => ({
  mode: 'text',
  compact: true,
  uppercase: false,
  contentStyle: {
    marginHorizontal: -5,
    marginVertical: -9,
  },
  labelStyle: { letterSpacing: 0, color: props.emphasize ? 'red' : Colors.secondary },
}))<CustomTextButtonProps>``;
